<div class="loader-kuaa d-flex flex-column justify-content-center align-items-center" id="loader-kuaa">
    <div class="loader"></div>
    <p class="title-loader">Estamos procesando la información, esto tardará unos minutos.</p>
</div>
